var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.16642 12.8336H2.33308V21.0002C2.33308 22.2871 3.37958 23.3336 4.66642 23.3336H18.6664C19.9533 23.3336 20.9998 22.2871 20.9998 21.0002V12.8336H22.1664C22.3971 12.8335 22.6226 12.7651 22.8145 12.6369C23.0063 12.5087 23.1558 12.3265 23.244 12.1133C23.3323 11.9002 23.3554 11.6656 23.3104 11.4394C23.2654 11.2131 23.1544 11.0052 22.9913 10.8421L12.4913 0.342068C12.383 0.233631 12.2544 0.147604 12.1129 0.0889079C11.9714 0.0302121 11.8196 0 11.6664 0C11.5132 0 11.3615 0.0302121 11.2199 0.0889079C11.0784 0.147604 10.9498 0.233631 10.8416 0.342068L0.341585 10.8421C0.178474 11.0052 0.0673995 11.2131 0.0224041 11.4394C-0.0225914 11.6656 0.000512109 11.9002 0.0887938 12.1133C0.177076 12.3265 0.326572 12.5087 0.518383 12.6369C0.710195 12.7651 0.935709 12.8335 1.16642 12.8336ZM9.33308 21.0002V15.1669H13.9998V21.0002H9.33308ZM11.6664 2.81657L18.6664 9.81657V15.1669L18.6676 21.0002H16.3331V15.1669C16.3331 13.8801 15.2866 12.8336 13.9998 12.8336H9.33308C8.04625 12.8336 6.99975 13.8801 6.99975 15.1669V21.0002H4.66642V9.81657L11.6664 2.81657Z",
    fill: "#023047"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.6bbd415144302caaa1d222acce4dddba.svg";
export { ForwardRef as ReactComponent };